import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract,NftPurchaseContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const PsTotalPurchase = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.chinaTomi;
  const contract = chinaContract(tokenAddress, web3);


  const psTotalPurchase = useCallback(
    async () => {
 
      try {
        const buy = await contract.methods.totalPurchases().call()
        return buy/10**18;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return { psTotalPurchase: psTotalPurchase };
};
export default PsTotalPurchase;